






import { Vue, Component, Prop } from 'nuxt-property-decorator';

const SYSTEM_COLOR_SCHEME = 'system';

@Component<BravadoTheme>({
  name: 'BravadoTheme',
  provide() {
    return {
      isDarkTheme: () => this.theme === 'dark',
    };
  },
  watch: {
    theme: {
      immediate: true,
      handler() {
        if (!this.isGlobal || this.forcedTheme) {
          return;
        }

        this.colorPreference = SYSTEM_COLOR_SCHEME;
        this.updatePreference();

        if (!process.client) return;

        window.requestAnimationFrame(this.updatePreferenceOnClient);
      },
    },
  },
})
export default class BravadoTheme extends Vue {
  @Prop({ type: String }) readonly forcedTheme?: string;
  @Prop({ type: Boolean, default: false }) readonly isGlobal?: boolean;

  protected colorPreference: string = SYSTEM_COLOR_SCHEME;

  get rootClass() {
    return {
      'bravado-theme': true,
      [`bravado-theme--${this.theme}`]: true,
      'bravado-theme--visible': this.isVisible,
    };
  }

  get isVisible() {
    return this.forcedTheme || (this.$colorMode && !this.$colorMode.unknown);
  }

  get theme() {
    let theme = SYSTEM_COLOR_SCHEME;

    if (this.forcedTheme) {
      theme = this.forcedTheme;
    } else if (!this.$auth.loggedIn || this.$auth.user.uiTheme === 'auto') {
      theme = this.$colorMode.value;
    } else {
      theme = this.$auth.user.uiTheme as string;
    }

    return theme;
  }

  updatePreference() {
    if (this.$auth.loggedIn && this.$auth.user.uiTheme !== 'auto') {
      this.colorPreference = this.$auth.user.uiTheme as string;
    }

    this.$colorMode.preference = this.colorPreference;
  }

  updatePreferenceOnClient() {
    window.localStorage.setItem('nuxt-color-mode', this.colorPreference);

    // @ts-ignore
    if (window.__NUXT_COLOR_MODE__) {
      // @ts-ignore
      window.__NUXT_COLOR_MODE__.preference = this.colorPreference;
    }
  }
}
